import { Card } from "@/components/ui/card"
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion"
import { Checkbox } from "@/components/ui/checkbox"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { FormatFilter } from "./filters/FormatFilter"
import { FocusAreaFilter } from "./filters/FocusAreaFilter"

interface OpportunitiesFiltersProps {
  focusArea: string[]
  setFocusArea: (value: string[]) => void
  beneficiaryType: string[]
  setBeneficiaryType: (value: string[]) => void
  format: string[]
  setFormat: (value: string[]) => void
  location?: string
  setLocation: (value?: string) => void
  availableFocusAreas: string[]
  availableBeneficiaryTypes: string[]
  availableFormats: string[]
  availableLocations: string[]
}

export const OpportunitiesFilters = ({
  focusArea,
  setFocusArea,
  beneficiaryType,
  setBeneficiaryType,
  format,
  setFormat,
  location,
  setLocation,
  availableFocusAreas,
  availableBeneficiaryTypes,
  availableFormats,
  availableLocations,
}: OpportunitiesFiltersProps) => {
  const handleCheckboxChange = (
    currentValue: string,
    currentArray: string[],
    onChange: (newValue: string[]) => void
  ) => {
    const newArray = currentArray.includes(currentValue)
      ? currentArray.filter(v => v !== currentValue)
      : [...currentArray, currentValue]
    onChange(newArray)
  }

  return (
    <div className="w-full space-y-4 sticky top-[80px] max-h-[calc(100vh-80px)] overflow-y-auto pb-6">
      <Accordion type="multiple" defaultValue={["format", "focus", "beneficiary", "location"]}>
        <AccordionItem value="focus">
          <AccordionTrigger className="text-sm font-medium">Focus Area</AccordionTrigger>
          <AccordionContent>
            <div className="space-y-2">
              {availableFocusAreas.map((area) => (
                <div key={area} className="flex items-center space-x-2">
                  <Checkbox
                    id={`focus-${area}`}
                    checked={focusArea.includes(area)}
                    onCheckedChange={() => handleCheckboxChange(area, focusArea, setFocusArea)}
                  />
                  <Label
                    htmlFor={`focus-${area}`}
                    className="text-sm font-normal cursor-pointer"
                  >
                    {area.replace('_', ' & ')}
                  </Label>
                </div>
              ))}
            </div>
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="beneficiary">
          <AccordionTrigger className="text-sm font-medium">Beneficiary Type</AccordionTrigger>
          <AccordionContent>
            <div className="space-y-2">
              {availableBeneficiaryTypes.map((type) => (
                <div key={type} className="flex items-center space-x-2">
                  <Checkbox
                    id={`beneficiary-${type}`}
                    checked={beneficiaryType.includes(type)}
                    onCheckedChange={() => handleCheckboxChange(type, beneficiaryType, setBeneficiaryType)}
                  />
                  <Label
                    htmlFor={`beneficiary-${type}`}
                    className="text-sm font-normal cursor-pointer"
                  >
                    {type}
                  </Label>
                </div>
              ))}
            </div>
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="format">
          <AccordionTrigger className="text-sm font-medium">Format</AccordionTrigger>
          <AccordionContent>
            <div className="space-y-2">
              {availableFormats.map((fmt) => (
                <div key={fmt} className="flex items-center space-x-2">
                  <Checkbox
                    id={`format-${fmt}`}
                    checked={format.includes(fmt)}
                    onCheckedChange={() => handleCheckboxChange(fmt, format, setFormat)}
                  />
                  <Label
                    htmlFor={`format-${fmt}`}
                    className="text-sm font-normal cursor-pointer"
                  >
                    {fmt.replace('_', ' ')}
                  </Label>
                </div>
              ))}
            </div>
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="location">
          <AccordionTrigger className="text-sm font-medium">Location</AccordionTrigger>
          <AccordionContent>
            <div className="space-y-4">
              <div>
                <Input
                  placeholder="Search locations..."
                  value={location || ''}
                  onChange={(e) => setLocation(e.target.value || undefined)}
                  className="w-full"
                />
              </div>
              <div className="space-y-2">
                <p className="text-xs text-muted-foreground">Popular locations:</p>
                {availableLocations.slice(0, 5).map((loc) => (
                  <div
                    key={loc}
                    className="text-sm cursor-pointer hover:text-blue-600"
                    onClick={() => setLocation(loc)}
                  >
                    {loc}
                  </div>
                ))}
              </div>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  )
}